import React from "react";
import Reveal from "../common/Reveal";

type Testimonial = {
  name: string;
  quote: string;
};

const TESTIMONIALS: Testimonial[] = [
  {
    name: "Akarsh Sharma",
    quote:
      "Pretty neat ngl, better experience than what you expect from online classes, clear instructions and solid curriculum.",
  },
  {
    name: "Shivam Vyas",
    quote:
      "Very helpful teaching methods, learned a lot even with my busy work schedule.",
  },
  {
    name: "Preeti Sachdeva",
    quote:
      "Absolutely amazing topics, I did not know what is actually required to know an instrument. They helped clear the confusion and showed the right path.",
  },
];

const Testimonials: React.FC = () => {
  return (
    <section
      id="testimonials"
      className="bg-primary py-20 sm:py-24"
    >
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="space-y-4 text-center">
          <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/45">
            Voices from learners
          </p>
          <h2 className="font-display text-3xl text-accentNavy sm:text-4xl lg:text-5xl">
            People who already picked up the uke.
          </h2>
          <p className="mx-auto max-w-2xl text-base text-accentNavy/70 lg:text-lg">
            A few words from learners who trusted the process, showed up
            consistently, and discovered that online classes can feel
            surprisingly personal.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, index) => (
            <Reveal
              key={t.name}
              delay={index * 90}
            >
              <article className="flex h-full flex-col justify-between rounded-3xl border border-accentNavy/10 bg-white/90 p-6 text-left shadow-[0_18px_50px_-30px_rgba(9,32,63,0.7)] transition-all duration-400 hover:-translate-y-1 hover:border-accentNavy/20 hover:shadow-[0_22px_60px_-35px_rgba(9,32,63,0.9)]">
                <p className="text-sm leading-relaxed text-accentNavy/80 lg:text-base">
                  <span className="mr-1 text-xl text-accentGold/70">&ldquo;</span>
                  <span className="italic">{t.quote}</span>
                  <span className="ml-1 text-xl text-accentGold/70">&rdquo;</span>
                </p>
                <div className="mt-6 flex items-center justify-between gap-3 border-t border-accentNavy/5 pt-4">
                  <div>
                    <p className="text-sm font-semibold text-accentNavy">
                      {t.name}
                    </p>
                    {/* <p className="text-xs uppercase tracking-[0.22em] text-accentNavy/50">
                      Ukulele learner
                    </p> */}
                  </div>
                  {/* <div className="flex items-center gap-1.5 rounded-full bg-accentNavy px-3 py-1.5">
                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-300" />
                    <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-primary/90">
                      Ongoing
                    </span>
                  </div> */}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

